import {getBookCategoriesAction} from "./actions";

export default (state={} , action) => {
    switch (action.type) {
        case getBookCategoriesAction.resultAction :
            return action.payload.data ;
        default :
            return state ;
    }
};